import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";
import {
	HOME_SORT_BY_METRICS_ORDER,
	MetricForTable,
	useMapMetricsForTable
} from "@models/Metric";
import { useMemo } from "react";
import { KeywordBase, useGetKeywordBaseData } from "@api/useGetKeywordBaseData";

const REQUEST_PATH: keyof paths = '/api/Search/GetTile';

export type HomeTilesRequestPayload = components["schemas"]["FlavorTracker.Entities.DTO.SearchPage.SearchPageRequest"];
type ResponseData = components["schemas"]["FlavorTracker.Entities.DTO.SearchPage.SearchPageTableResponse"][];

export type HomeTileDataItem = KeywordBase & {
	base: number;
	metrics: MetricForTable[];
}

export function useHomeTilesData(payload: HomeTilesRequestPayload) {
	const getKeywordBaseData = useGetKeywordBaseData(["knowItChange", "thumbnailUrl", "primaryCategoryId"]);
	const mapMetricsForTable = useMapMetricsForTable(HOME_SORT_BY_METRICS_ORDER);

	const response = useAxios<ResponseData, HomeTilesRequestPayload>({
		url: REQUEST_PATH,
		method: 'post',
		payload,
	});

	const data = useMemo(
		(): HomeTileDataItem[] => {
			return (response.data ?? []).map(item => {
				const itemBase = getKeywordBaseData(item.id ?? 0);

				return {
					...itemBase,
					base: item.base ?? 0,
					metrics: mapMetricsForTable(item.metrics ?? []),
				};
			});
		},
		[response.data, getKeywordBaseData, mapMetricsForTable]
	);

	return {
		...response,
		data,
	};
}